import React from 'react';
import { DollarSign, FileText, CheckCircle, TrendingUp, Shield, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import descriptionImage from '../../assets/business-people-working-as-team-conference-room-plans-future_482257-25781.jpg_nur6h3.jpg';

const LoansAndGrantsPage = () => {
  const services = [
    {
      icon: DollarSign,
      title: 'Business Loans',
      description: 'Access flexible business financing options with competitive rates and terms designed to support your business growth and expansion plans.'
    },
    {
      icon: FileText,
      title: 'Personal Loans',
      description: 'Personal loan solutions for various needs including debt consolidation, home improvements, education, and other personal financial goals.'
    },
    {
      icon: CheckCircle,
      title: 'Grant Programs',
      description: 'Information and assistance with grant applications for businesses, individuals, and organizations seeking funding opportunities.'
    },
    {
      icon: TrendingUp,
      title: 'Investment Loans',
      description: 'Specialized loan products for investors and members looking to finance investment opportunities with flexible repayment terms.'
    },
    {
      icon: Shield,
      title: 'Loan Management',
      description: 'Comprehensive loan management services including application assistance, documentation support, and ongoing account management.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/80 to-navy-800/60"></div>
        <div className="absolute inset-0">
          <img
            src="/images/money-5029288_1280.jpg"
            alt="Loans and Grants"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold font-serif mb-4">Loans and Grants</h1>
          <p className="text-xl md:text-2xl text-gray-200">
            Home / <span className="text-gold-400">Sectors</span> / <span className="text-gold-400">Loans and Grants</span>
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold font-serif text-navy-900 mb-6">
              Financing <span className="text-gold-600">Solutions</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Access easy financing options with our streamlined loan process. We provide flexible loan offers for dedicated members and investors with competitive rates and terms.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Whether you need funding for business expansion, personal goals, or investment opportunities, our loans and grants services offer comprehensive solutions. We also provide assistance with grant applications and ongoing loan management to support your financial needs.
              </p>
            </div>
            
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                <img
                  src={descriptionImage}
                  alt="Loans and Grants Services"
                  className="w-full h-96 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900/50 to-transparent"></div>
              </div>
            </div>
          </div>

          {/* Services Section */}
          <div className="mb-20">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => {
                const IconComponent = service.icon;
                return (
                  <div key={index} className="group bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                    <div className="inline-flex p-4 bg-gradient-to-r from-gold-500 to-gold-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                    <h4 className="text-xl font-bold text-navy-900 mb-4">
                      {service.title}
                    </h4>
                    <p className="text-gray-600 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-2xl p-12 text-center text-white">
            <h3 className="text-3xl md:text-4xl font-bold font-serif mb-6">
              Ready to Explore Financing Options?
            </h3>
            <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
              Discover flexible loan and grant opportunities tailored to your needs. 
              Get started with our streamlined application process today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-gold-600 hover:bg-gold-700 text-white font-bold rounded-full transition-colors duration-300"
              >
                Apply Now
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link 
                to="/#investment-sectors"
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-navy-900 font-bold rounded-full transition-all duration-300"
              >
                View All Sectors
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoansAndGrantsPage;

